import { Container } from "./style";
import { isMobile } from "react-device-detect";


export default function ApplyPage() {
  return (
    <Container>
      <div className="inner page_inner">
        <strong className={`top_text ${isMobile ? 'fs20' : 'fs30'}`}>아래 이메일 주소로 자문 신청 바랍니다.</strong>
        <p className={isMobile ? 'fs14' : 'fs16'}>kalhi@naver.com</p>
        <p className={isMobile ? 'fs14' : 'fs16'}>분몬 - 자유형식</p>
        <p className={isMobile ? 'fs14' : 'fs16'}>첨부자료 - 내용증명, 고소장, 소장, 상세페이지 중 가지고 있는 자료</p>
        <p className={isMobile ? 'fs14' : 'fs16'}><strong className="green">성함</strong>과 <strong className="green">전화번호</strong>를 반드시 첨부 부탁드립니다.</p>
      </div>
    </Container>
  )
}